import ModifierTitle from "./ModifierTitle"
import Options from "./Options"
import OptionsAggregate from "./OptionsAggregate"

import classes from './ProductModifiers.module.css'
import { useState } from "react"
import SpecialModifiers from "./SpecialModifiers"

const ProductModifier = ({modifier, product}) => {
    const [hideModifier, setHideModifier] = useState(false)  // swift product hide modifier
    function hideModifierHandler(hide) {
        if (modifier && modifier.description === "Name Customization") {
            setHideModifier(true)
        }
    }

    return <div className={classes.modifier_item}>  
    <SpecialModifiers product={product} modifier={modifier} hideModifier={hideModifierHandler}/> 
        <ModifierTitle modifier={modifier} changeTitle={hideModifier}/>
        {!hideModifier && (
            <>
                {modifier.options && !modifier.maxaggregatequantity && <Options options={modifier.options} parentModifier={modifier}/>}
                {modifier.options && modifier.maxaggregatequantity && <OptionsAggregate options={modifier.options} parentModifier={modifier}/>}
            </>
        )   }
        {/* {modifier.options && !modifier.maxaggregatequantity && <Options options={modifier.options} parentModifier={modifier}/>}
        {modifier.options && modifier.maxaggregatequantity && <OptionsAggregate options={modifier.options} parentModifier={modifier}/>} */}
    </div>
}

export default ProductModifier